import * as types from './mutations-types'
import cardOperationApi from '../../../../../api/wx-member/go-out-management/card-operation/card-operation'
import dictionaryApi from '../../../../../api/dict/dictionary-api'
import * as DataTypeConstants from '../../../../../constants/DataTypeConstants'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import FormatTableFieldUtils from '../../../../../common/utils/format-table-field-util'

export default {
  getMembersByPage: ({commit}, pageData) => {
    cardOperationApi.getMembersByPage(pageData)
      .then(result => {
        commit(types.SEARCH_MEMBER_RESULT, result)
      })
  },
  grantOfCouponByData: ({commit}, data) => {
    return new Promise(resolve => {
      cardOperationApi.grantOfCouponByData(data)
        .then(result => {
          // commit(types.SEARCH_MEMBER_RESULT, result)
          resolve(result)
        })
    })
  },
  getCouponsInfo: ({commit}, codes) => {
    cardOperationApi.getCouponsInfo(codes)
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'couponType',
            fieldPropName: 'couponTypeName',
            fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
          }
        ]
        FormatTableFieldUtils.formatTableFieldName(result, params).then(res => {
          commit(types.COUPONS_INFO, res)
        })
      })
  },
  getApprovalByMemberId: ({commit}, codes) => {
    return new Promise(resolve => {
      cardOperationApi.getApprovalByMemberId(codes)
        .then(result => {
          let params = [
            {
              fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
              fieldPropCode: 'couponType',
              fieldPropName: 'couponTypeName',
              fieldFormatParam: DictionaryConstants.COUPON_CUPON_TYPE
            },
            {
              fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
              fieldPropCode: 'couponDepartment',
              fieldPropName: 'couponDepartmentName',
              fieldFormatParam: DictionaryConstants.DEPARTMENT
            },
            {
              fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
              fieldPropCode: 'expiresType',
              fieldPropName: 'expiresTypeName',
              fieldFormatParam: DictionaryConstants.COUPON_EXPIRES_TYPE
            }
          ]
          if (result.length <= 0) {
            commit(types.PENDING_APPROVAL_COUPONS, result)
            return false
          }
          FormatTableFieldUtils.formatTableFieldName(result[0].couponInstanceDTOList, params).then(res => {
            result[0].couponInstanceDTOList = res
            commit(types.PENDING_APPROVAL_COUPONS, result)
          })
          resolve(result)
        })
    })
  },
  couponApproval: ({commit}, data) => {
    return new Promise(resolve => {
      cardOperationApi.couponApproval(data)
        .then(result => {
          resolve(result)
        })
    })
  },
  getApplicationTypeOptions: ({commit}, code) => {
    dictionaryApi.getDictInfosByTypeCode(code)
      .then(result => {
        commit(types.OUTSIDE_THE_STORE_APPLICATION_TYPE_OPTIONS, result)
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/card-operation/store/actions.js